import React, { useState } from 'react';
import { CaseHeader } from '../components/CaseHeader';
import { DepositionOutline } from '../components/DepositionOutline';
import { FileTextIcon, SettingsIcon, UserIcon, Wand2Icon } from 'lucide-react';
export function DepositionPage() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 1500);
  };
  return <div className="flex flex-col h-full w-full overflow-hidden bg-navy" data-id="element-290">
      <CaseHeader data-id="element-291" />

      <div className="flex-1 overflow-hidden flex" data-id="element-292">
        {/* Left Panel - Controls */}
        <div className="w-[400px] border-r border-navy-border bg-navy-surface flex flex-col flex-shrink-0 overflow-y-auto" data-id="element-293">
          <div className="p-5 border-b border-navy-border" data-id="element-294">
            <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-295">
              <FileTextIcon size={18} className="text-accent-amber" data-id="element-296" />
              Deposition Builder
            </h2>
            <p className="text-xs text-text-secondary mt-1" data-id="element-297">
              Generate structured outlines from the discovery record.
            </p>
          </div>

          <div className="p-5 space-y-6 flex-1" data-id="element-298">
            <div className="space-y-2" data-id="element-299">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider flex items-center gap-2" data-id="element-300">
                <UserIcon size={14} data-id="element-301" />
                Deponent
              </label>
              <select className="input-field" data-id="element-302">
                <option value="" data-id="element-303">Select a witness...</option>
                <option value="smith" data-id="element-304">
                  John Smith (VP Construction, Blackstone)
                </option>
                <option value="johnson" data-id="element-305">
                  Mary Johnson (General Counsel, Blackstone)
                </option>
                <option value="davis" data-id="element-306">
                  Robert Davis (Site Manager, Greenfield)
                </option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-307">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider flex items-center gap-2" data-id="element-308">
                <SettingsIcon size={14} data-id="element-309" />
                Focus Topics (Optional)
              </label>
              <div className="space-y-2" data-id="element-310">
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-311">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" defaultChecked data-id="element-312" />
                  Contract Drafting & Review
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-313">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" defaultChecked data-id="element-314" />
                  Notice of Water Intrusion
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-315">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" data-id="element-316" />
                  Damages Calculation
                </label>
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer hover:text-white transition-colors" data-id="element-317">
                  <input type="checkbox" className="rounded-sm border-navy-border bg-navy text-accent-amber focus:ring-accent-amber focus:ring-offset-navy" data-id="element-318" />
                  Subcontractor Communications
                </label>
              </div>
            </div>

            <div className="space-y-2" data-id="element-319">
              <label className="text-xs font-semibold text-text-muted uppercase tracking-wider" data-id="element-320">
                Custom Instructions / Prompt
              </label>
              <textarea className="input-field min-h-[120px] resize-none text-sm" placeholder="e.g., Focus heavily on contradictions between ROG 3 and the daily site logs regarding the timeline of when they knew about the pooling water. Include specific Bates numbers for exhibits." defaultValue="Focus heavily on contradictions between ROG 3 and the daily site logs regarding the timeline of when they knew about the pooling water. Include specific Bates numbers for exhibits." data-id="element-321" />
            </div>
          </div>

          <div className="p-5 border-t border-navy-border bg-navy" data-id="element-322">
            <button onClick={handleGenerate} disabled={isGenerating} className="btn-primary w-full flex justify-center items-center gap-2 py-3" data-id="element-323">
              {isGenerating ? <span className="flex items-center gap-2" data-id="element-324">
                  <div className="w-4 h-4 border-2 border-navy border-t-transparent rounded-full animate-spin" data-id="element-325"></div>
                  Analyzing Record...
                </span> : <span className="flex items-center gap-2" data-id="element-326">
                  <Wand2Icon size={16} data-id="element-327" />
                  Generate Deposition Outline
                </span>}
            </button>
          </div>
        </div>

        {/* Right Panel - Outline View */}
        <div className="flex-1 bg-[#0A121C] p-6 overflow-hidden" data-id="element-328">
          {hasGenerated ? <div className="h-full animate-in fade-in zoom-in-95 duration-300" data-id="element-329">
              <DepositionOutline data-id="element-330" />
            </div> : <div className="h-full flex flex-col items-center justify-center text-text-muted border-2 border-dashed border-navy-border rounded-sm" data-id="element-331">
              <FileTextIcon size={48} className="mb-4 opacity-20" data-id="element-332" />
              <p className="text-sm" data-id="element-333">
                Select a deponent and generate an outline to view it here.
              </p>
              <p className="text-xs mt-2 opacity-60" data-id="element-334">
                The outline will cross-reference all available discovery
                responses.
              </p>
            </div>}
        </div>
      </div>
    </div>;
}